<template>
  <div>
    <div v-if="loading" class="loadData w-100 d-flex justify-content-center align-items-center">
      <b-spinner
        variant="primary"
        class="text-center"
      />
    </div>
    <div v-else>
      <GeneralSummary />
      <HoldingEnterprises :loading="loading"/>
      <PaginationTransactionality
        :show="transactionalityPagination.totalPaginas > 1"
        v-model="page"
      />
      <BillingInformation class="mt-5" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

import GeneralSummary from '@/febos/global/operations/components/transactionality/GeneralSummary';
import HoldingEnterprises from '@/febos/global/operations/components/transactionality/HoldingEnterprises';
import BillingInformation from '@/febos/global/operations/components/transactionality/BillingInformation';
import PaginationTransactionality from '@/febos/global/operations/components/transactionality/PaginationTransactionality';
import { updateSearchParams } from '@/febos/global/utils/router';

export default {
  name: 'TransaccionalityDetail',
  props: ['filter'],
  components: {
    GeneralSummary,
    HoldingEnterprises,
    BillingInformation,
    PaginationTransactionality
  },
  data() {
    return {
      page: parseInt(this.$route.query.page, 10) || 1,
      filters: [],
      loading: false,
      filteredData: []
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      await this.debounceFetchByRut();
    },
    async filters() {
      await this.debounceFetchByRut();
    },
    filter(val) {
      this.manageFilter(val);
    }
  },
  computed: {
    ...mapGetters('Operations', ['transactionalityPagination'])
  },
  methods: {
    ...mapActions('Operations', ['getTransaccionality']),
    debounceFetchByRut: _.debounce(async function debounceFetchByRut() {
      this.loading = true;
      await this.fetchData();
      this.loading = false;
    }, 350),
    async fetchData() {
      this.loading = true;
      const periodParam = this.$moment().subtract(1, 'month').format('YYYY-MM-DD');
      try {
        const data = await this.getTransaccionality({
          params: {
            filtros: this.filters.map((f) => f.filter).join('|'),
            periodo: periodParam,
            paginaActual: this.page,
            elementosPorPagina: 10,
          }
        });
        this.filteredData = data;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.loading = false;
      }
    },
    manageFilter(obj) {
      this.filters = this.filters.filter((f) => f.name !== obj.filterName);
      if (obj.filter === '*' || obj.filter === '') return;
      this.filters.push({
        name: obj.filterName,
        filter: obj.filter
      });
    }
  },
  async created() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
};
</script>
<style scoped>
.loadData {
  height: 80vh;
}
</style>
